export const authServer = process.env.VUE_APP_AUTH_URI;
export const apiServerLogistica = process.env.VUE_APP_API_URI_LOGISTICA;
export const apiServerBI = process.env.VUE_APP_API_URI_BI;
export const apiServer = process.env.VUE_APP_API_URI;
export const apiServerV2 = process.env.VUE_APP_API_URI;
export const cexSeguimientoEnvio = process.env.VUE_APP_CEX_SEGUIMIENTO_URI;
export const appVersion = "1.3.3707";
export const apiKeyMaps = "AIzaSyA6HMe4l770I-piy4a9b6FYWybU0v93ORs";
